import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { GaWizard } from '../../shared/wizard/ga-wizard';
import { StateService, Transition, TransitionService } from '@uirouter/angular';
import { UPLOAD_CONFIG } from './upload-config';
import { IUploadModel, UPLOAD_STEP1, UPLOAD_STEP2, UPLOAD_STEP3, UPLOAD_WIZARD, UploadService } from './upload.service';
import * as _ from 'underscore';
import { STATE_UPLOAD_WIZARD_STEP1, STATE_UPLOAD_WIZARD_STEP2, STATE_UPLOAD_WIZARD_STEP3, STATE_UPLOAD_WIZARD_STEP4 } from '../../shared/app-states';
import { Subscription } from 'rxjs';
import { TranslationService } from '../../shared/translation/translation.service';
import { GaWizardService } from '../../shared/wizard/ga-wizard.service';
import { UploadStepOneComponent } from './upload-step-one.component';
import { UploadStepTwoComponent } from './upload-step-two.component';
import { UploadStepThreeComponent } from './upload-step-three.component';
import { GaStateDeclaration } from '../../../type_definitions/datatypes';

@Component({
  selector: 'upload',
  template: `
    <wizard-wrapper [loading]="loading" [wizardTitle]="title" [error]="error" [wizardId]="wizardId"></wizard-wrapper>
  `
})
export class UploadComponent implements OnInit, OnDestroy {
  @Input() public code:string;

  public wizardId:string = UPLOAD_WIZARD;
  public error:string;
  public loading:string;
  public title:string = 'Upload';

  private wizard:GaWizard;
  private modelChangeSubscription:Subscription;
  private onStateChangeSuccessListener:Function;

  constructor(
    private wizardService:GaWizardService,
    private transition:Transition,
    private transitionService:TransitionService,
    private stateService:StateService,
    private uploadService:UploadService,
    private translateService:TranslationService
  ) {
    /**/
  }

  public ngOnInit():void {
    if (this.code && !UPLOAD_CONFIG[ this.code ]) {
      this.error = this.translateService.instant('GA.UPLOADS.NO_ACCESS');
    } else {
      // init wizard
      this.initWizard();
    }

    // register listener
    this.listen();
  }

  public ngOnDestroy():void {
    this.modelChangeSubscription.unsubscribe();
    this.onStateChangeSuccessListener();
    this.uploadService.model = {};
    this.wizard.clear();
  }

  private listen():void {
    this.modelChangeSubscription = this.uploadService.modelChanges.subscribe((model:IUploadModel) => {
      if (!model?.context) {
        this.stateService.go(STATE_UPLOAD_WIZARD_STEP1, { code: this.code });
      }

      if (model?.context && !_.isEmpty(model.context)) {
        this.wizard.enabled(UPLOAD_STEP2, true);
      }

      if (model?.uploadContext) {
        this.wizard.enabled(UPLOAD_STEP3, true);
      }
    });

    this.onStateChangeSuccessListener = this.transitionService.onSuccess({}, (transition:Transition) => {
      const from:GaStateDeclaration = transition.from();
      const to:GaStateDeclaration = transition.to();

      // this is to prevent user accessing /results and redirect to step 1 then need to recreate the steps and synced
      if (from?.name === STATE_UPLOAD_WIZARD_STEP4) {
        this.initWizard();
      }

      // if accessing route directly to results page without clearing previous step then prevent state change
      if (to?.name === STATE_UPLOAD_WIZARD_STEP4 && !this.uploadService.model?.uploadContext?.importId) {
        this.stateService.go(from?.name, { code: this.code });
      }
    });
  }

  private initWizard():void {
    this.wizard = this.wizardService.getInstance(UPLOAD_WIZARD);

    this.wizard.steps([
      this.wizardService.createStep(UPLOAD_STEP1, UPLOAD_CONFIG[ this.code ]?.title, UploadStepOneComponent, STATE_UPLOAD_WIZARD_STEP1, this.transition.params(), undefined, true),
      this.wizardService.createStep(UPLOAD_STEP2, 'GA.UPLOADS.CHOOSE_FILE', UploadStepTwoComponent, STATE_UPLOAD_WIZARD_STEP2, this.transition.params(), undefined, false),
      this.wizardService.createStep(UPLOAD_STEP3, 'GA.UPLOADS.SELECT_COLUMNS', UploadStepThreeComponent, STATE_UPLOAD_WIZARD_STEP3, this.transition.params(), undefined, false, 'GA.UPLOADS.SELECT_COLUMNS_REASON')
    ]);

    if (this.stateService.current.name !== STATE_UPLOAD_WIZARD_STEP4) {
      this.wizard.sync();
    }
  }
}